import React from 'react';

const AppButton = ({
  children,
  variant = 'primary', // 'primary', 'secondary', 'accent', 'ghost', 'link', 'outline', 'error', 'success', 'warning', 'info'
  size = 'md', // 'xs', 'sm', 'md', 'lg'
  type = 'button',
  loading = false,
  icon,
  iconPos = 'left',
  disabled = false,
  className = '',
  onClick,
  ...rest
}) => {
  // Determine variant class
  let variantClass = '';
  switch (variant) {
    case 'primary': variantClass = 'btn-primary text-white'; break;
    case 'secondary': variantClass = 'btn-secondary'; break;
    case 'accent': variantClass = 'btn-accent'; break;
    case 'ghost': variantClass = 'btn-ghost'; break;
    case 'link': variantClass = 'btn-link'; break;
    case 'outline': variantClass = 'btn-outline'; break;
    case 'error': variantClass = 'btn-error text-white'; break;
    case 'success': variantClass = 'btn-success text-white'; break;
    case 'warning': variantClass = 'btn-warning'; break;
    case 'info': variantClass = 'btn-info text-white'; break;
    default: variantClass = 'btn-primary text-white'; break;
  }

  // Determine size class
  let sizeClass = '';
  switch (size) {
    case 'xs': sizeClass = 'btn-xs'; break;
    case 'sm': sizeClass = 'btn-sm'; break;
    case 'lg': sizeClass = 'btn-lg'; break;
    case 'md': 
    default: sizeClass = ''; break; // md is default in daisyui
  }

  // Icon element
  const renderIcon = () => {
    if (loading) {
      return <span className="loading loading-spinner loading-sm mr-1"></span>;
    }
    if (icon) {
      return <i className={`${icon} ${children ? (iconPos === 'left' ? 'mr-2' : 'ml-2') : ''}`}></i>;
    }
    return null;
  };

  return (
    <button
      type={type}
      className={`btn ${variantClass} ${sizeClass} ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
      {...rest}
    >
      {iconPos === 'left' && renderIcon()}
      {children}
      {iconPos === 'right' && renderIcon()}
    </button>
  );
};

export default AppButton;
